<res-base-modal [modalTitle]="modalTitle" [modalClass]="modalClass" [modalAutomationId]="modalAutomationId"
    (primaryButtonActionEmt)="ok()" (closeButtonActionEmt)="closeModal()" [modalHelpIndex]="modalHelpIndex"
    [isPrimaryBtnEnabled]="okEnabled() && !isSaveDisabled" [secondaryButtonLabel]="'Cancel'" [primaryButtonLabel]="'OK'"
    [resizeHorizontal]="true" [resizeHorizontalMin]="400" [resizeVertical]="true" [resizeVerticalMin]="400"
    [maximizable]="true" [(isBusy)]="isBusy" [(isBusyMessage)]="isBusyMessage">


    <res-left-right-selection-box [automationId]="modalAutomationId" [sortItemsLeft]="true" [sortItemsRight]="true" 
        [useTrees]="true" [itemsLeft]="itemsLeft"
        [itemsRight]="itemsRight" [disabledItemsFirst]="true" [isBusyLeft]="isBusyLeft" [isBusyMessageLeft]="isBusyMessageLeft"  (customMoveItems)="customMoveItems($event)"
        leftListTitle="Available" rightListTitle="Assigned " [rightListRequired]="!isGroup()" [rightListHasSelectionColumn] ="modalData.membershipType === 'organization' ? true : false"
        [rightListTemplate]="rightListTemplate" [leftListTemplate]="leftListTemplate" [rightListHeight]="modalData.membershipType === 'organization' ? 50 : 30">
    </res-left-right-selection-box>
    <ng-template #rightListTemplate>
        <res-filter [placeholder]='"Filter by Name ..."' [maxChars]=32 [callback]="filterDataRight.bind(this)"
            [filterInputAutoId]="modalAutomationId + '-right'" [clearButtonDataAutoId]="modalAutomationId + '-right'">
        </res-filter>
        <div class="list-header">
            <div class="checkbox-header">
                <res-custom-checkbox [automationId]="'assigned-select-all'" [isIndeterminate]="isRightListPartiallySelected()"
                     [(ngModel)]="rightSelectAllChecked" (ngModelChange)="rightSelectionChanged($event)" [isDisabled]="rightSelectAllDisabled">
                </res-custom-checkbox>
            </div>
            <div class="column-name column-header">
                <span>Name</span>
            </div>
            <div class="column-role column-header">
                <span>{{modalData.membershipType !== 'organization' ? 'Project Role' : 'Role'}}</span>
            </div>
        </div>
    </ng-template>
    <ng-template #leftListTemplate>
        <res-filter [placeholder]='"Filter by Name ..."' [maxChars]=32 [callback]="filterDataLeft.bind(this)"
            [filterInputAutoId]="modalAutomationId + '-left'" [clearButtonDataAutoId]="modalAutomationId + '-left'">
        </res-filter>
        <div class="list-header">
             <div class="checkbox-header">
                <res-custom-checkbox [automationId]="'available-select-all'" [isIndeterminate]="isLeftListPartiallySelected()"
                     [(ngModel)]="leftSelectAllChecked" (ngModelChange)="leftSelectionChanged($event)" [isDisabled]="leftSelectAllDisabled">
                </res-custom-checkbox>
            </div>
            <div class="column-header" [ngClass]="[modalData.membershipType !== 'organization' ? 'column-name' : 'column-name-full-width']">
                <span>Name</span>
            </div>
            <div *ngIf="modalData.membershipType !== 'organization'" class="column-role column-header">
                <span>Role</span>
            </div>
        </div>
    </ng-template>
</res-base-modal>